export enum ShareType {
    'Residents' = 'residents',
    'Groups' = 'groups',
    'Public' = 'public',
}



// WEBPACK FOOTER //
// /app/src/app/types/documents/share-types.ts